import React, {useContext, useEffect, useState} from 'react';
import Box from '@mui/material/Box';
import {Grid} from '@mui/material';
import Typography from '@mui/material/Typography';
import './Banner.scss';
import Carousel from 'react-multi-carousel';
import {DispatchContext} from '../../../store';
import {museumApi, museumServicesAction} from '../../../services/MuseumServices';
import {SNACKBAR_OPEN} from '../../../reducers';
import NoDataFound from '../../../common/NoDataFound/NoDataFound';
import {museumList} from '../../../services/InvitationServices';

export default function Banner() {
  const dispatch = useContext(DispatchContext);
  const [open, setOpen] = React.useState(false);
  const [museums, setMuseums] = useState([]);
  const [museumId, setMuseumId] = useState(null);

  useEffect(() => {
    getMuseums();
  }, []);

  const getMuseums = () => {
    museumList('get', null, null).then(res => {
      setMuseums(res?.data);
    })
  }

  const deleteMuseum = (id) => {
    museumServicesAction('delete', id).then(res => {
      dispatch({
        type: SNACKBAR_OPEN,
        payload: {isNotify: true, severity: 'success', message: 'Museum Deleted successfully'}
      });
    })
  }

  const handleOpen = () => {
    setOpen(true);
    setMuseumId(null);
  };

  const handleClose = () => {
    setOpen(false);
    setMuseumId(null);
  };

  return (
    <Box>
      <Grid container sx={{mt: {sm: 0.5, xs: 0}, mb: 3}}>
        <Grid item sm={1}/>
        <Grid item sm={10}>
          <Typography className={'bannerTitle text-500 museum-font-family'}>
            THE MUSEUMS OF BHUTAN
          </Typography>
          <Typography className={'font15 museum-font-family'} style={{textAlign: 'center'}}>
            Department of Culture and Dzongkhag Development is devoted to the
          </Typography>
          <Typography className={'font15 museum-font-family'} sx={{textAlign: 'center', mb: 1}}>
            study, collection of artifacts from 60’s to the present
          </Typography>
        </Grid>
      </Grid>
      <Carousel
        swipeable={true}
        draggable={true}
        showDots={false}
        autoPlay={true}
        responsive={responsive}
        ssr={true}
        infinite={true}
        autoPlaySpeed={2000}
        keyBoardControl={true}
        customTransition="transform 500ms ease-in-out"
        transitionDuration={500}
        containerClass="carousel-container"
        removeArrowOnDeviceType={['tablet', 'mobile']}
        // removeArrowOnDeviceType={['both']}
        dotListClass="custom-dot-list-style"
        itemClass="carousel-item-padding-40-px"
      >
        {museums?.length > 0 ? (
          museums?.map((item, index) => (
            <Box key={index} className="carousel-item">
              <Box className={'position-relative'}>
                <img
                  draggable={'false'}
                  src={`${item?.photos?.[0]?.file}?show=true`}
                  alt={item?.name}
                  loading="lazy"
                  style={{width: '99%', height: 300, objectFit: "cover"}}
                />
                <Box className={'position-absolute'} sx={{bottom: 12, left: 12, right: 0}}>
                  <Grid container>
                    <Grid item sm={10}>
                      <Typography className={'text-capitalize text-shadow white-color font-16 text-bold'}>{item?.name}</Typography>
                      <Typography
                        className={'text-shadow white-color font-14'}>{item?.gewog_name + ', ' + item?.dzongkhag_name + ' Bhutan' || 'Nil'}</Typography>
                    </Grid>
                  </Grid>
                </Box>
              </Box>
              {/*<div>*/}
              {/*  <Typography>{truncate(item.description, 250)}</Typography>*/}
              {/*</div>*/}
            </Box>
          ))
        ) : (
          <div style={{width: '100vw'}}>
            <NoDataFound width={'20%'} height={'20%'}/>
          </div>
        )}
      </Carousel>
    </Box>
  );
}

const responsive = {
  superLargeDesktop: {
    breakpoint: {max: 4000, min: 3000},
    items: 5
  },
  desktop: {
    breakpoint: {max: 3000, min: 1024},
    items: 3
  },
  tablet: {
    breakpoint: {max: 1024, min: 464},
    items: 2
  },
  mobile: {
    breakpoint: {max: 464, min: 0},
    items: 1,
    draggable: true
  }
};